module.exports = __webpack_public_path__ + "023ab383e3ef4403a7e70eac6fb3eb03.webp";